var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeSmileySizesWeightfilled = function SvgTypeSmileySizesWeightfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "M10 1.875A8.125 8.125 0 1 0 18.125 10 8.133 8.133 0 0 0 10 1.875M7.188 7.5a.937.937 0 1 1 0 1.875.937.937 0 0 1 0-1.875m6.478 4.688c-.804 1.39-2.14 2.187-3.666 2.187s-2.862-.797-3.666-2.187a.625.625 0 1 1 1.082-.626c.583 1.01 1.5 1.563 2.584 1.563s2-.555 2.584-1.562a.625.625 0 1 1 1.082.624m-.854-2.813a.937.937 0 1 1 0-1.874.937.937 0 0 1 0 1.874"
  })));
};
export default SvgTypeSmileySizesWeightfilled;